import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-layout__shell" }
const _hoisted_2 = { class: "default-layout__main" }

import { onMounted, onUnmounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import Header from '@/components/Header.vue';
import AppFooter from '@/components/AppFooter.vue';
import ProductTourHost from '@/components/onboarding/ProductTourHost.vue';
import CreditorAccessBanner from '@/components/superadmin/CreditorAccessBanner.vue';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useNotificationsStore } from '@/stores/notifications';
import { useSettingsStore } from '@/stores/settings';
import { useSuperAdminCreditorAccessStore } from '@/stores/superAdminCreditorAccess';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const router = useRouter();
const accountStore = useAccountStore();
const authStore = useAuthStore();
const notificationsStore = useNotificationsStore();
const settingsStore = useSettingsStore();
const creditorAccessStore = useSuperAdminCreditorAccessStore();
const { user } = storeToRefs(authStore);
const { creditorName, isActive: isCreditorAccessActive } = storeToRefs(creditorAccessStore);

onMounted(() => {
    accountStore.fetchAccountSettings();
    accountStore.fetchDevices();
    settingsStore.fetchCompanySettings();
});

let stopWatching: (() => void) | undefined;

// `let` avoids the temporal dead zone when this immediate watcher stops itself.
// eslint-disable-next-line prefer-const
stopWatching = watch(user, async (newUser) => {
    if (!newUser?.id) return;

    stopWatching?.();
    await notificationsStore.fetchUnreadCount();
    notificationsStore.listenForNewNotifications(newUser.id);
}, { immediate: true });

onUnmounted(() => {
    stopWatching?.();
    if (authStore.user?.id) {
        notificationsStore.stopListening(authStore.user.id);
    }
});

async function handleExitCreditorAccess(): Promise<void> {
    await creditorAccessStore.exitAccess();
    await router.push({ name: 'superadmin-creditors' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["default-layout", { 'default-layout--with-creditor-access': _unref(isCreditorAccessActive) }])
  }, [
    (_unref(isCreditorAccessActive))
      ? (_openBlock(), _createBlock(CreditorAccessBanner, {
          key: 0,
          "creditor-name": _unref(creditorName),
          onExit: handleExitCreditorAccess
        }, null, 8, ["creditor-name"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header),
      _createElementVNode("main", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(AppFooter)
    ]),
    _createVNode(ProductTourHost)
  ], 2))
}
}

})